import { Card, Button, Dropdown } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import {
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
} from "../../../components"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable.js"
import React, { useEffect, useState } from "react"
import lawyerLanguageService from "../services/lawyer_languagesService"

const Lawyer_languagesList = () => {
  const navigate = useNavigate()
  const [lawyer_languagesData, setLawyer_languages] = useState([])
  const [loading, setLoading] = useState(false)
  const [languageData, setLanguage] = useState([])
  const [lawyerData, setLawyer] = useState([])

  useEffect(() => {
    setLoading(true)
    fetchLawyer_languagesList()
    fetchLanguageList()
    fetchLawyerList()
  }, [])

  const fetchLanguageList = async () => {
    try {
      const language = await lawyerLanguageService.getLanguageList()
      setLanguage(language)
    } catch (error) {
      console.log("Error fetching language list:", error)
    }
  }

  const fetchLawyerList = async () => {
    try {
      const lawyer = await lawyerLanguageService.getLawyerList()
      setLawyer(lawyer)
    } catch (error) {
      console.log("Error fetching lawyer list:", error)
    }
  }

  const fetchLawyer_languagesList = async () => {
    try {
      const response = await lawyerLanguageService.getLawyer_languagesList()
      setLawyer_languages(response)
      setLoading(false)
    } catch (error) {
      console.log("Error fetching lawyer_languages list:", error)
      setLoading(false)
    }
  }

  const handleDeleteLawyer_languages = async (lawyer_languagesId) => {
    try {
      setLoading(true)
      await lawyerLanguageService.deleteLawyer_languages(lawyer_languagesId)
      const data = lawyer_languagesData.filter(
        (rows) => rows.id != lawyer_languagesId
      )
      setLawyer_languages(data)
      setLoading(false)
    } catch (error) {
      console.log("Error deleting lawyer_languages:", error)
      setLoading(false)
    }
  }

  const handleCreateLawyer_languages = () => {
    navigate("/lawyer_languages/new")
  }

  const lawyer_languagesColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "language",
      selector: (row) => {
        const language = languageData.find(
          (language) => language.id === row.language
        )
        return language ? language.name : ""
      },
      sortable: true,
      cell: (row) => {
        const language = languageData.find(
          (language) => language.id === row.language
        )
        return language ? language.name : ""
      },
    },
    {
      name: "lawyer",
      selector: (row) => {
        const lawyer = lawyerData.find((lawyer) => lawyer.id === row.lawyer)
        return lawyer ? lawyer.name : ""
      },
      sortable: true,
      cell: (row) => {
        const lawyer = lawyerData.find((lawyer) => lawyer.id === row.lawyer)
        return lawyer ? lawyer.name : ""
      },
    },
    {
      name: "actions",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu-sm"
              as={CustomDropdownMenu}
              align="end"
            >
              <div className="dropdown-content py-1">
                <LinkList className="link-list-hover-bg-primary link-list-md">
                  <Link
                    to={`/lawyer_languages/edit/${row.id}`}
                    className="dropdown-item"
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Link>
                  <button
                    className="dropdown-item"
                    onClick={() => handleDeleteLawyer_languages(row.id)}
                  >
                    <Icon name="trash" />
                    <span>Delete</span>
                  </button>
                </LinkList>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ]

  return (
    <Layout title="Lawyer_languages List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Lawyer_languages List</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Lawyer_languages
                </li>
              </ol>
            </nav>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleCreateLawyer_languages}
                >
                  <Icon name="plus" />
                  <span>Add</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleCreateLawyer_languages}
                >
                  <Icon name="plus" />
                  <span>Add Lawyer_languages</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          {!loading ? (
            <DataTable
              tableClassName="data-table-head-light table-responsive"
              data={lawyer_languagesData}
              columns={lawyer_languagesColumns}
              expandableRows
              actions
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card>
      </Block>
    </Layout>
  )
}

export default Lawyer_languagesList
